var map = {
	"./Cognizant.png": 83,
	"./Infosys.png": 84,
	"./Jenkin_logo.png": 85,
	"./Tech_hamindra_logo.png": 86,
	"./Wipro.png": 87,
	"./Wipro_1.png": 88,
	"./address_image.svg": 89,
	"./animated_ashutosh.png": 90,
	"./animated_logo.svg": 91,
	"./blogs_image.svg": 92,
	"./cloud_infrastructure.svg": 93,
	"./codeInLogo.png": 94,
	"./contactMail.png": 95,
	"./coursera_logo.png": 96,
	"./data_science.svg": 97,
	"./deeplearning_ai_logo.png": 98,
	"./delhivery_logo.png": 99,
	"./developerActivity.svg": 100,
	"./dsc_logo.png": 101,
	"./education.svg": 102,
	"./experience.svg": 103,
	"./feelingProud.svg": 104,
	"./freecopy_logo.png": 105,
	"./fullstack.svg": 106,
	"./gcp_logo.png": 107,
	"./github_logo.png": 108,
	"./googleAssistant.jpg": 109,
	"./googleAssistant.svg": 110,
	"./google_logo.png": 111,
	"./ibm_logo.png": 112,
	"./iiitk_logo.png": 113,
	"./intel_logo.jpg": 114,
	"./iu_logo.png": 115,
	"./jsFramework.svg": 116,
	"./legato_logo.png": 117,
	"./manOnTable.svg": 118,
	"./microsoft_logo.png": 119,
	"./mozilla_logo.png": 120,
	"./muffito_logo.png": 121,
	"./nextuLogo.jpg": 122,
	"./nptel_logo.png": 123,
	"./portfolio.gif": 124,
	"./programmer.svg": 125,
	"./projects_image.svg": 126,
	"./pwa.png": 127,
	"./saayaHealthLogo.png": 128,
	"./stanford_logo.png": 129,
	"./talksCardBack.svg": 130,
	"./talksCardBackAlt.svg": 131,
	"./tiktok_logo.png": 132,
	"./ui_ux_design.svg": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;